export const logger = {
  info: (message: string, ...meta: any[]) => {
    console.log(`[INFO] ${new Date().toISOString()} - ${message}`, ...meta);
  },
  warn: (message: string, ...meta: any[]) => {
    console.warn(`[WARN] ${new Date().toISOString()} - ${message}`, ...meta);
  },
  error: (message: any, error?: any, ...meta: any[]) => {
    const msgString = typeof message === 'string' ? message : (message instanceof Error ? message.message : String(message));
    const errObj = typeof message === 'string' ? error : (error || message);
    console.error(`[ERROR] ${new Date().toISOString()} - ${msgString}`, errObj, ...meta);
  },
  debug: (message: string, ...meta: any[]) => {
    if (process.env.NODE_ENV !== 'production') {
      console.debug(`[DEBUG] ${new Date().toISOString()} - ${message}`, ...meta);
    }
  }
};
